import type { Analytics } from "firebase/analytics"
import type { RouteLocationNormalized } from "vue-router"
import { getAnalytics, isSupported, logEvent } from "firebase/analytics"
import { getApps, initializeApp } from "firebase/app"
import { useCookieConsentStore } from "@/stores/cookieConsent"

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

const instance = {
	analytics: null as Analytics | null
}

export function useFirebase() {
	async function initAnalytics() {
		const cookieConsentStore = useCookieConsentStore()

		if ((await isSupported()) && !instance.analytics && cookieConsentStore.analyticsAccepted) {
			const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

			instance.analytics = getAnalytics(app)
		}
	}

	function logPageView(currentRoute: RouteLocationNormalized) {
		const cookieConsentStore = useCookieConsentStore()

		if (instance.analytics && cookieConsentStore.analyticsAccepted) {
			logEvent(instance.analytics, "page_view", {
				page_path: currentRoute.fullPath,
				page_title: document.title
			})
		}
	}

	return {
		initAnalytics,
		logPageView
	}
}
